import { ADDRESS_FIELDS_FRAGMENT } from '@/components/addresses/address-input';
import { gql } from '@apollo/client';
import { VARIANTS_PACK_FRAGMENT } from './items-context-queries';

export const SAMPLE_REQUEST_FRAGMENT = gql`
  fragment SampleRequestFields on sample_requests {
    address {
      ...AddressInputFields
    }
    contact_email
    follow_up_response
    follow_up_submitted_at
    qualified_at
    requested_at
    requested_by {
      name
      supplier_employee_overrides(
        where: { supplier_uuid: { _eq: $supplierUUID } }
      ) {
        name
        uuid
      }
      uuid
    }
    status
    uuid
  }

  ${ADDRESS_FIELDS_FRAGMENT}
`;

export const DISPLAY_AD_CONTEXT_QUERY = gql`
  fragment DisplayAdVariantPackFields on GetDisplayAdVariantPacksEventsResponse {
    ad_campaign_id
    ad_manager_id
    advertiser_id
    gtin
    display_ad_content {
      banner_image_url
      description
      desktop_banner_image_url
      event_data {
        click_event_id
        impression_event_id
      }
      logo_image_url
      title
    }
    variant_pack {
      ...ItemsContext_VariantsPackFields
    }
    variant_pack_event_data {
      add_to_cart_event_id
      click_event_id
      impression_event_id
      purchase_event_id
    }
  }

  query Ads_DisplayAdContext(
    $locale: String!
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
    $supplierUUID: uuid!
  ) {
    getDisplayAdVariantPacksEvents(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...DisplayAdVariantPackFields
    }
  }

  ${VARIANTS_PACK_FRAGMENT}
`;

export const SAMPLE_REQUEST_CONTEXT_QUERY = gql`
  fragment SampleRequestVariantPackFields on GetSampleRequestVariantPacksResponse {
    ad_campaign_id
    ad_manager_id
    advertiser_id
    advertiser_name
    gtin
    earliest_requested_at
    follow_up_period_days
    lookback_period_days
    qualification_questions
    request_count
    request_limit
    require_contact_information
    sample_request_event_data {
      add_to_cart_event_id
      click_event_id
      form_submit_event_id
      impression_event_id
      purchase_event_id
    }
    sample_request {
      ...SampleRequestFields
    }
    variant_pack {
      ...ItemsContext_VariantsPackFields
    }
    variant_pack_id
  }

  query Ads_SampleRequestContext(
    $locale: String!
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
    $supplierUUID: uuid!
  ) {
    getSampleRequestVariantPacks(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...SampleRequestVariantPackFields
    }
  }

  ${SAMPLE_REQUEST_FRAGMENT}
  ${VARIANTS_PACK_FRAGMENT}
`;
